import React, { FC, ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { RoutesProvider } from "./RoutesContext";
import { IRoutes } from "@Libs/Router/types";

import { IAppRoute } from "@App/types";
import { IRouteOptions } from "../types/routes";

export type IGenerateRouteKey =
  | IAppRoute[]
  | IAppRoute
  | {
      segments: IAppRoute[] | IAppRoute;
      options?: Omit<IRouteOptions, "matchAny">;
    };

interface IRoutesProviderProps {
  routes: IRoutes;
  children: ReactNode;
}

type IRouterProviderProps = IRoutesProviderProps;

export const RouterProvider: FC<IRouterProviderProps> = ({
  children,
  routes,
}) => {
  return (
    <RoutesProvider routes={routes}>
      <BrowserRouter>{children}</BrowserRouter>
    </RoutesProvider>
  );
};
